<div class="layout-content outer" [ngStyle]="currentStyles">
    <div class="middle grid">
      <div class="inner col-12 md:col-8 lg:col-6 grid-nogutter" style="max-width: 900px">
        <div class="no-auth-box" [ngClass]="panelClass">
          <router-outlet></router-outlet>
        </div>
      </div>
  </div>
  </div>
